const getters = {
  account: state => state.user.account,
  name: state => state.user.name,
  roles: state => state.user.roles,
  permission_routes: state => state.permission.routes,
  addRoutes: state => state.permission.addRoutes,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js